import {useState} from 'react';
import {FormValuesWinners} from '@/pages/Organization/AddWinnerPage';
import {AddWinnerStyles} from '@/pages/Organization/AddWinnerPage/AddWinnerStyle.styles';
import Button from '@/shared/components/Button';
import Modal from '@/shared/components/Modal';
import {ADD_WINNER, CANCEL, OUTLINED, SAVE_CHANGES} from '@/utils/constants';
import {ReactComponent as DangerIcon} from '@/assets/icons/danger.svg';
import {Box, Drawer, useMediaQuery} from '@mui/material';
import {useFormikContext} from 'formik';
import {useNavigate} from 'react-router-dom';

const AddWinnerActions = () => {
	const navigate = useNavigate();
	const {submitForm, values} = useFormikContext<FormValuesWinners>();

	const [isOpenModal, setIsOpenModal] = useState(false);

	const handleModal = () => setIsOpenModal(!isOpenModal);

	const hasUnsavedChanges = values.winners.some((winner) =>
		[winner.itemNumber, winner.bidderNumber, winner.bidAmount].some((value) => value.trim() !== '')
	);

	const handleNavigate = () => {
		if (!hasUnsavedChanges) {
			navigate(-1);
			return;
		}

		handleModal();
	};

	const isMobile = useMediaQuery('(max-width:639.98px)');

	return (
		<Box>
			<Drawer variant="permanent" anchor="bottom" sx={AddWinnerStyles.drawer}>
				<Box sx={AddWinnerStyles.popup}>
					<Button title={CANCEL} variant={OUTLINED} onClick={handleNavigate} sx={AddWinnerStyles.cancelBtn} />
					<Button title={isMobile ? ADD_WINNER : SAVE_CHANGES} onClick={submitForm} />
				</Box>
			</Drawer>
			<Modal
				open={isOpenModal}
				title="Are you sure?"
				description="Are you sure you want to leave this page?
Changes that you made may not be saved."
				color="error"
				mainIcon={<DangerIcon />}
				isShowCloseButton
				isShowSaveButton
				closeButtonTitle="Leave Without Saving"
				mainButtonTitle={CANCEL}
				onSave={handleModal}
				onClose={() => navigate(-1)}
				sx={AddWinnerStyles.modal}
			/>
		</Box>
	);
};

export default AddWinnerActions;
